<template>
<!-- eslint-disable max-len -->
<div class="container" v-show="showForm">
<div class="row no-gutters">
<div class="list-form col-sm-12">
  <template v-if="editing && !isProfessor && !hideButtons">
    <a v-if="canDeepDelete && deepDeleteCollection"
      href=""
      class="btn delete-btn float-sm-right"
      @click.prevent="onClickRequestSafeDeepDelete"
      :disabled="deleting"
    >Request Safe Deep Delete</a>
    <a href=""
      class="btn delete-btn float-sm-right"
      style="margin-right: 10px;"
      @click.prevent="onClickDelete"
      :disabled="deleting"
    >Delete</a>
    <a href=""
      class="btn delete-btn float-sm-right"
      style="margin-right: 10px;"
      @click.prevent="onCopy"
      :disabled="copying || $v.model.$invalid"
    >Copy</a>
  </template>

  <h2>{{ titleString }} {{ name | capitalize }}</h2>

  <form>
    <button
      v-if="!hideButtons || showSubmit"
      type="submit"
      class="btn"
      style="margin-bottom: 15px; font-size: 100%;"
      @click.prevent="() => onSubmit()"
      :disabled="submitted || $v.model.$invalid">
      {{ actionString }}<!-- {{ editing ? ' And Return To List' : '' }} -->
    </button>

    <slot
      :model="model"
      :enums="enums"
      :utils="utils"
      :validator="$v.model"
      :creating="creating"
      :editing="editing"
    ></slot>

    <button
      v-if="!hideButtons || showSubmit"
      type="submit"
      class="btn"
      style="font-size: 100%;"
      @click.prevent="() => onSubmit()"
      :disabled="submitted || $v.model.$invalid">
      {{ actionString }}<!-- {{ editing ? ' And Return To List' : '' }} -->
    </button>

    <button
      v-if="editing && (!hideButtons || showSubmit)"
      class="btn"
      style="position: fixed; bottom: 8px; right: 8px;"
      @click.prevent="() => onSubmit(true)"
      :disabled="submitted || $v.model.$invalid">
      {{ actionString }} And Stay On Page
    </button>

    <button
      v-if="editing && (!hideButtons || showSubmit) && $v.model.$invalid"
      class="btn"
      style="position: fixed; bottom: 50px; right: 8px;"
      @click.prevent="onClickRevalidate()"
      :disabled="submitted">
      Revalidate
    </button>

    <!-- <div
      v-if="$v.model.$invalid"
      style="position: fixed; top: 50px; right: 8px; z-index: 1000; background-color: black; color: white; max-height: 70vh; max-width: 40vw; overflow: auto;">
      {{ $v }}
    </div> -->
  </form>
</div>
</div>
<b-modal
  ref="multiDeleteModal"
  size="lg"
  centered
  hide-footer
  title="Confirm Multi Delete"
>
  <!-- {{deleteMap}} -->
  Delete this {{name}} and everything it references that isn't referenced by another {{name}}.
  The following stuff was found to be referenced by this {{name}} and no other {{name}}.
  Uncheck anything you don't want to delete, then click Confirm.
  <br>
  <br>
  <template v-if="deleteMap && Object.keys(deleteMap)">
  <div v-for="(deleteList, i) in Object.keys(deleteMap)" :key="i">
    {{deleteListDisplay[deleteList] || deleteList}}
    <b-checkbox v-for="(deleteItem, j) in deleteMap[deleteList]" :key="j" v-model="deleteItem.keep"
    >{{deleteItem.name}}</b-checkbox>
  </div>
  <button v-if="canDeepDelete && deepDeleteCollection"
    class="btn"
    @click.prevent="onClickMultiDelete"
    :disabled="deleting"
  >Confirm Multi Delete</button>
  </template>
</b-modal>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { incrementVersionCheckerProtectionCount, decrementVersionCheckerProtectionCount } from '../../../utils/version';

export default {
  props: {
    name: { type: String, required: true },
    modelName: { type: String, required: true },
    deepDeleteCollection: { type: String, default: '' },
    param: { type: String, required: true },
    pagePrefix: { type: String, required: true },
    create: { type: Function, required: true },
    fetch: { type: Function, required: true },
    fetchTypes: { type: Function, default: () => Promise.resolve({}) },
    update: { type: Function, required: true },
    remove: { type: Function, required: true },
    hideButtons: Boolean,
    showSubmit: Boolean,
    enumNames: { type: Array, default: () => [] },
    stub: { type: Object, required: true },
    validator: { type: Object, default: () => {} },
    utils: { type: Object, default: () => {} },
    watchers: { type: Array, default: () => [] }
  },
  data() {
    const state = {
      deleteMap: null,
      deleting: false,
      submitted: false,
      copying: false,
      showForm: false
    };

    state.enums = this.enumNames.reduce((acc, enumName) => {
      acc[enumName] = [];
      return acc;
    }, {});

    state.model = this.stub;

    state.deleteListDisplay = {
      games: 'Gamulations',
      outros: 'Endgame Settings',
      challenges: 'Sections',
      teamdecisions: 'Major Decisions',
      individualdecisions: 'Minor Decisions',
      environments: 'Gamulation Brandings',
      roles: 'Roles',
      characters: 'Characters',
      metrics: 'Metrics',
    };

    return state;
  },
  async created() {
    this.showForm = this.creating;

    try {
      const data = await (this.creating ? this.fetchTypes() : this.fetch(this.idParam));
      const model = this.modelName ? data[this.modelName] : data;
      if (model) this.model = model;

      this.enumNames.forEach((enumName) => {
        this.enums[enumName] = data[enumName];
      });

      this.watchers.forEach(({ field, watcher }) => {
        this.$watch(field, (newValue, oldValue) => {
          watcher(this.model, newValue, oldValue);
        });
      });
    } catch (_) {
      console.error(_);
      const message = `Error getting ${this.name} record, please try again`;
      this.flashDanger({ message });
      this.$router.push(this.pagePrefix);
    }
    this.$emit('initialized');
  },
  async mounted() {
    incrementVersionCheckerProtectionCount();
    if (this.editing) {
      // hack to override v-focus on nested inputs
      await new Promise(resolve => setTimeout(resolve, 250));
      this.scrollToTop();
      this.showForm = true;
    }
  },
  destroyed() {
    decrementVersionCheckerProtectionCount();
  },
  computed: {
    ...mapGetters([
      'editUpdateSubmitter',
      'canDeepDelete',
      'isProfessor'
    ]),
    idParam() {
      return { [this.param]: this.$route.params[this.param] };
    },
    creating() {
      return !this.$route.params[this.param];
    },
    editing() {
      return !!this.$route.params[this.param];
    },
    titleString() {
      return this.creating ? 'Create' : 'Edit';
    },
    actionString() {
      return this.creating ? 'Create' : 'Update';
    }
  },
  watch: {
    editUpdateSubmitter() {
      this.onSubmit(true);
    },
  },
  methods: {
    ...mapActions([
      'flashDanger',
      'flashSuccess',
      'requestSafeDeepDelete',
      'multiDelete',
      'scrollToTop'
    ]),
    async onCopy() {
      if (this.copying) return;
      this.copying = true;
      await this.onSubmit();
      this.copying = false;
    },
    async onSubmit(noNav = false) {
      if (this.submitted) return;
      this.submitted = true;

      try {
        if (this.copying) this.model._id = '';
        await (this.creating || this.copying ? this.create(this.model) : this.update(this.model));
        const message = `${this.name} ${this.creating ? 'created' : 'updated'} successfully`;
        this.flashSuccess({ message });
        if (!noNav) this.$router.push(this.pagePrefix);
        else this.submitted = false;
      } catch (err) {
        const { data = {} } = err && err.response || {};
        const duplicateEmail = !!data.email;
        const actionName = this.copying ? 'copying' : this.creating ? 'creating' : 'updating';
        const message =
          duplicateEmail ? 'Email is already is use, please try again.' :
            `Error ${actionName} ${this.name}, please try again`;
        this.flashDanger({ message });
        this.submitted = false;
      }
    },
    async onClickDelete() {
      // eslint-disable-next-line no-alert
      if (!window.confirm('Are you sure you want to delete this?')) return;
      if (this.deleting) return;
      this.deleting = true;

      try {
        await this.remove(this.idParam);
        const message = `${this.name} deleted successfully`;
        this.flashSuccess({ message });
        this.$router.replace(this.pagePrefix);
      } catch (_) {
        const message = `Error deleting ${this.name}, please try again`;
        this.flashDanger({ message });
        this.deleting = false;
      }
    },
    async onClickRequestSafeDeepDelete() {
      try {
        this.deleteMap = await this.requestSafeDeepDelete({
          collection: this.deepDeleteCollection, _id: this.$route.params[this.param]
        });
        Object.keys(this.deleteMap).forEach((key) => {
          this.deleteMap[key].forEach((n) => { n.keep = true; });
        });
        this.$refs.multiDeleteModal.show();
      } catch (_) {
        const message = `Error constructing deletion list for ${this.name}, please try again`;
        this.flashDanger({ message });
      }
    },
    async onClickMultiDelete() {
      // eslint-disable-next-line no-alert
      if (!window.confirm('Are you sure you want to deep delete this?')) return;
      if (this.deleting) return;
      this.deleting = true;

      try {
        const confirmedDeleteMap = {};
        Object.keys(this.deleteMap).forEach((key) => {
          const nodeArray = this.deleteMap[key];
          const confirmedNodeArray = nodeArray.filter(({ keep }) => keep);
          confirmedDeleteMap[key] = confirmedNodeArray;
        });
        await this.multiDelete({ deleteMap: confirmedDeleteMap });
        const message = `${this.name} deep deleted successfully`;
        this.flashSuccess({ message });
        this.$router.replace(this.pagePrefix);
      } catch (_) {
        const message = `Error deep deleting ${this.name}, please try again`;
        this.flashDanger({ message });
        this.deleting = false;
      }
    },
    async onClickRevalidate() {
      if (this.model.name) {
        const oldName = this.model.name;
        this.model.name = `.${this.model.name}`;
        await this.$nextTick();
        this.model.name = oldName;
      }
    },
  },
  validations() {
    return {
      model: this.validator
    };
  }
};
</script>

<style lang="scss" scoped>
.list-form {
  background-color: white;
  margin-top: 50px;
  padding: 20px;
}
select.form-control {
  margin-bottom: 5px;
}
.delete-btn {
  margin: -10px -10px 15px auto;
  line-height: 2em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/pages/EditPage.vue